import Select from "react-select"
import HeaderFilters from "components/Shared/HeaderFilters/HeaderFilters"
import { GET_ITEM_LIMIT } from "constants/constants"
import { Pagination } from "@wfp/ui"
import BaseTable, { AutoResizer, Column, ColumnShape } from "react-base-table"
import { useState } from "react"
import { GorpViewDataRegional } from "interfaces/dataInterfaces"
import { useGetGorpsByRegionQuery, useGetYearsQuery } from "services/gorp"
import { regions } from "./EditData"

export default function ViewDataRegional() {
  const [pageNumber, setPageNumber] = useState(1)
  const [getItemLimit, setGetItemLimit] = useState(GET_ITEM_LIMIT)
  const [year, setYear] = useState(null)
  const [month, setMonth] = useState(null)
  const [regionCode, setRegionCode] = useState("")

  const { data: years } = useGetYearsQuery()
  const { data: gorpsByRegion } = useGetGorpsByRegionQuery({
    year,
    month,
    regionCode,
    skip: pageNumber === 1 ? 0 : (pageNumber - 1) * getItemLimit,
    top: getItemLimit,
  })

  const yearData = [{ value: 0, label: "All years" }]
  years?.map(c => {
    yearData.push({
      value: Number(c.value),
      label: c.name,
    })
  })

  const monthData = [
    { value: 0, label: "All months" },
    { value: 1, label: "Jan" },
    { value: 2, label: "Feb" },
    { value: 3, label: "Mar" },
    { value: 4, label: "Apr" },
    { value: 5, label: "May" },
    { value: 6, label: "Jun" },
    { value: 7, label: "Jul" },
    { value: 8, label: "Aug" },
    { value: 9, label: "Sep" },
    { value: 10, label: "Oct" },
    { value: 11, label: "Nov" },
    { value: 12, label: "Dec" },
  ]

  const getRegiondata = async (event: any) => {
    setRegionCode(event.value)
  }

  const getYeardata = async (event: any) => {
    setYear(event.value)
  }

  const getMonthdata = async (event: any) => {
    setMonth(event.value)
  }

  const centeredHeaderRenderer = ({ column }) => (
    <div className="BaseTable__header-cell-text text-center">{column.title}</div>
  )

  const columns: Array<ColumnShape<GorpViewDataRegional>> = [
    {
      key: "gorpDateYear",
      dataKey: "gorpDateYear",
      title: "Year",
      width: 80,
      align: Column.Alignment.CENTER,
      headerRenderer: centeredHeaderRenderer,
    },
    {
      key: "gorpDateMonth",
      dataKey: "gorpDateMonth",
      title: "Month",
      width: 80,
      align: Column.Alignment.CENTER,
      headerRenderer: centeredHeaderRenderer,
    },
    {
      key: "gorpRegionName",
      dataKey: "gorpRegionName",
      title: "Region",
      width: 80,
      align: Column.Alignment.CENTER,
      headerRenderer: centeredHeaderRenderer,
    },
    {
      key: "gorpTotalValue",
      dataKey: "gorpTotalValue",
      title: "Total Value",
      width: 150,
      align: Column.Alignment.RIGHT,
      headerRenderer: centeredHeaderRenderer,
    },
    {
      key: "gorpMainValue",
      dataKey: "gorpMainValue",
      title: "Main Value",
      width: 150,
      align: Column.Alignment.RIGHT,
      headerRenderer: centeredHeaderRenderer,
    },
    {
      key: "gorpAdditionalRefugeesValue",
      dataKey: "gorpAdditionalRefugeesValue",
      title: "Refugees Value",
      width: 150,
      align: Column.Alignment.RIGHT,
      headerRenderer: centeredHeaderRenderer,
    },
    {
      key: "gorpAdditionalIdpvalue",
      dataKey: "gorpAdditionalIdpvalue",
      title: "IDP Value",
      width: 150,
      align: Column.Alignment.RIGHT,
      headerRenderer: centeredHeaderRenderer,
    },
    {
      key: "gorpNoCountries",
      dataKey: "gorpNoCountries",
      title: "No of Countries",
      width: 150,
      align: Column.Alignment.CENTER,
      headerRenderer: centeredHeaderRenderer,
    },
  ]

  return (
    <>
      <HeaderFilters>
        <div className="d-flex" style={{ width: "60%" }}>
          <Select
            isSearchable
            className="dropdown mr-4"
            classNamePrefix="select"
            placeholder="Select Year"
            options={yearData}
            onChange={value => getYeardata(value)}
          />
          <Select
            isSearchable
            className="dropdown mr-4"
            classNamePrefix="select"
            placeholder="Select Month"
            options={monthData}
            onChange={value => getMonthdata(value)}
          />
          <Select
            isSearchable
            className="dropdown"
            classNamePrefix="select"
            placeholder="Select Region"
            options={[{ value: undefined, label: "All regions" }].concat(regions as any)}
            onChange={value => getRegiondata(value)}
          />
        </div>
      </HeaderFilters>
      <div style={{ marginBottom: "20px" }} />

      <div style={{ height: "100%", minHeight: "60vh" }}>
        <AutoResizer>
          {({ width, height }) => (
            <BaseTable
              data={gorpsByRegion?.items}
              width={width}
              height={height}
              rowKey="gorpID"
              className="custom-table"
              rowHeight={38}
              headerHeight={45}
              columns={columns}
              emptyRenderer={() => <p>No records to display</p>}
            />
          )}
        </AutoResizer>
      </div>

      <Pagination
        totalItems={gorpsByRegion?.count ?? 0}
        pageSize={getItemLimit}
        pageSizes={[10, 20, 30]}
        page={pageNumber}
        onChange={(event: any): void => {
          setPageNumber((event as any).page)
          setGetItemLimit((event as any).pageSize)
        }}
      />
    </>
  )
}
